import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { ContactRelationshipsService, PatientsService } from '../../../../../core/lists';
import { FormControl } from '@angular/forms';
import { OfficesService } from '../../../../../core/management';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { MedReviewService } from '../../services/med-review.service';
import * as moment from 'moment';

@Component({
  selector: 'kt-med-review-filter',
  templateUrl: './med-review-filter.component.html',
  styleUrls: ['./med-review-filter.component.scss'],
})
export class MedReviewFilterComponent implements OnInit {
  constructor(
    public stringUtilsService: StringUtilsService,
    private patientsService: PatientsService,
    private officesService: OfficesService,
    private medReviewService: MedReviewService,
    private relationshipsService: ContactRelationshipsService,
    private cdr: ChangeDetectorRef,
  ) {}

  @Output() filterChange = new EventEmitter<any>();
  filterPatientFn = this.patientsService.searchPatients.bind(this.patientsService);
  facilityAutocompleteCall = this.patientsService.searchFacilities.bind(this.patientsService);
  fromDate = new FormControl();
  toDate = new FormControl();
  facility: any;
  patient: any;
  officeAutocompleteCall = this.officesService.searchOffices.bind(this.officesService);
  office: any;
  @Input() filter;
  badge = new FormControl();
  fromDateModel: any;
  toDateModel: any;

  @ViewChild('patientAutocomplete') patientAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('facilityAutocomplete') facilityAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('officeAutocompleteComponent')
  officeAutocompleteComponent: GeneralAutocompleteComponent;
  isCycle = false;
  getDoctorAutocomplete = this.relationshipsService.searchEntities.bind(this.relationshipsService, {
    type: 'DOCTOR',
  });
  @ViewChild('doctorAutocomplete', { static: true })
  doctorAutocomplete: GeneralAutocompleteComponent;

  officeOptionFormatter = (val) => (val && val.name ? val.name : '');

  ngOnInit(): void {
    const date = new Date();
    const obj = {
      startDate: new Date().setDate(date.getDate() - 7),
      toDate: new Date().setDate(date.getDate() + 7),
    };
    this.fromDate.setValue(obj.startDate);
    if (this.filter) {
      setTimeout(() => {
        this.fromDate.setValue(this.filter.from_date);
        this.toDate.setValue(this.filter.to_date);
        if (this.filter.facility) this.facilityAutocomplete.setValue(this.filter.facility);
        if (this.filter.patient) this.patientAutocomplete.setValue(this.filter.patient);
        if (this.filter.office) this.officeAutocompleteComponent.setValue(this.filter.office);
        if (this.filter.doctor) this.doctorAutocomplete.setValue(this.filter.doctor);
      }, 100);
    }
  }

  selectedPatient(value): void {
    this.patient = value;
    this.dispatchEvent();
  }

  onFacilityChange(value) {
    this.facility = value;
    this.dispatchEvent();
  }

  dispatchEvent() {
    const startValue = this.fromDate?.value;
    const endValue = this.toDate?.value;
    const filter: any = {};
    filter.from_date = startValue ? moment(startValue).format('YYYY-MM-DD') : null;
    filter.to_date = endValue ? moment(endValue).format('YYYY-MM-DD') : null;
    filter.facility = this.facility;
    filter.patient = this.patient;
    filter.office = this.office;
    filter.badge = this.badge.value;
    filter.doctor = this.doctorAutocomplete.value;
    this.filterChange.emit(filter);
  }

  onOfficeChange(value) {
    this.office = value;
    this.dispatchEvent();
  }

  clearDateFilter() {
    this.fromDate.setValue(null);
    this.toDate.setValue(null);
    this.dispatchEvent();
  }

  badgeChange() {
    this.dispatchEvent();
  }

  cycleDateWithin7Days() {
    this.isCycle = !this.isCycle;
    const date = new Date();
    const obj = {
      startDate: new Date().setDate(date.getDate() - 7),
      toDate: new Date().setDate(date.getDate() + 7),
    };
    this.fromDate.setValue(obj.startDate);
    this.toDate.setValue(obj.toDate);
    this.fromDate.setValue(new Date(obj.startDate));
    this.toDate.setValue(new Date(obj.toDate));
    this.cdr.detectChanges();
    this.dispatchEvent();
  }
}
